var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPasswordView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.30273 0.791016C4.1724 0.885102 3.08691 1.27576 2.15586 1.92356C1.2248 2.57135 0.481156 3.45333 0 4.48046C0.481156 5.50759 1.2248 6.38963 2.15586 7.03742C3.08691 7.68522 4.1724 8.07588 5.30273 8.16996C6.51224 8.15731 7.69372 7.80462 8.71224 7.15219C9.73077 6.49976 10.5452 5.57388 11.0625 4.48046C10.5452 3.38705 9.73077 2.46122 8.71224 1.80879C7.69372 1.15636 6.51224 0.803671 5.30273 0.791016V0.791016ZM5.53134 2.50004C6.05655 2.5002 6.56022 2.70889 6.93159 3.08027C7.30297 3.45164 7.51171 3.95526 7.51188 4.48046C7.51171 5.00566 7.30297 5.50934 6.93159 5.88071C6.56022 6.25209 6.05655 6.46078 5.53134 6.46094C5.00614 6.46078 4.50258 6.25209 4.13121 5.88071C3.75983 5.50934 3.55109 5.00566 3.55092 4.48046C3.55109 3.95526 3.75983 3.45164 4.13121 3.08027C4.50258 2.70889 5.00614 2.5002 5.53134 2.50004V2.50004Z",
    fill: "#B3B3B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_57"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.0625,
    height: 8.96094,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPasswordView);
export default __webpack_public_path__ + "static/media/icon_password_view.05fe5e467c9118d7dc00a6c7482daaf8.svg";
export { ForwardRef as ReactComponent };